(function () {
    'use strict';

    angular
        .module('app')
        .controller('UploadFileController', UploadFileController);

    UploadFileController.$inject = ['$http', '$scope'];

    function UploadFileController($http, $scope) {
        var vm = this;
        vm.$onInit = init;
        vm.imageChosen = imageChosen;
        vm.clearImage = clearImage;
        var element;

        function init() {
        }

        function imageChosen(event) {
            if(vm.change) {vm.change();}
            vm.error = "";
            element = event.srcElement;
            var file = event.srcElement.files[0];
            vm.file_name = file.name.length < 16 ? file.name : file.name.substring(0,6) + '...' + file.name.substring(file.name.length-6);

            var reader = new FileReader();
            reader.onloadend = function() {
                vm.base64 = reader.result;
            }
            reader.readAsDataURL(file);

            vm.file_size = (file.size / 1000000).toFixed(2);
            if (vm.file_size < 10) {
                vm.file = file;
            } else {
                clearImage();
                vm.error = "file_size";
            }
        }

        function clearImage() {
            element.value = "";
            vm.file_name = "";
        }
    }

})();
